import { TrackerCustomEvent } from '.';

type ActionType = 'CLK' | string;
// 映射关系类型
interface EventMapping {
  [key: string]: {
    eventName: string;
    action?: ActionType; // 默认为事件类型
    paramsMapper?: (params: any) => any;
    desc?: string;
  };
}
/**
 * paramsMapper命名最好要与事件名称一致，方便Posthog统计数据采用
 * **/
// 创建事件参数到参数的映射配置
export const EVENT_MAPPING: EventMapping = {
  [TrackerCustomEvent.CrashLog]: {
    eventName: '崩溃日志',
    paramsMapper: params => {
      return {
        '[崩溃日志]安卓ID': params.c1,
        '[崩溃日志]发生时间': params.c2,
        '[崩溃日志]设备信息': params.c3,
        '[崩溃日志]原始日志': params.c4,
      };
    },
  },
  //没用到
  [TrackerCustomEvent.DeviceMemoryMonitor]: {
    eventName: '设备内存监测',
    paramsMapper: params => {
      return {
        '[设备内存监测]设备总内存': params.c1,
        '[设备内存监测]diskFree': params.c2,
        '[设备内存监测]diskTotal': params.c3,
        '[设备内存监测]realDiskFree': params.c4,
        '[设备内存监测]realDiskTotal': params.c5,
        '[设备内存监测]raw data': params.c6,
        '[设备内存监测]report time': params.c7,
        '[设备内存监测]android id': params.c8,
      };
    },
  },
  [TrackerCustomEvent.GetAndroidIdError]: {
    eventName: '获取安卓ID失败',
    paramsMapper: params => {
      return { '[获取安卓ID失败]错误详情': params.c1 };
    },
  },
  [TrackerCustomEvent.HelpFeedbackClk]: {
    eventName: '点击【帮助反馈】',
  },
  [TrackerCustomEvent.IssueFeedbackClk]: {
    eventName: '点击【问题反馈】',
  },
  [TrackerCustomEvent.ReportIssueClk]: {
    eventName: '点击【立即上报】',
  },
  [TrackerCustomEvent.IssueProgressClk]: {
    eventName: '点击【问题处理进度】',
  },
  [TrackerCustomEvent.SubmitIssueClk]: {
    eventName: '反馈模块 - 点击【提交】',
  },
  [TrackerCustomEvent.UsingSkillClk]: {
    eventName: '点击【使用技巧】',
  },
  [TrackerCustomEvent.QuickGuideClk]: {
    eventName: '点击【快速指南】',
  },
  // ---帮助反馈模块改版后，埋点未用到----
  [TrackerCustomEvent.YzcSkillVideoClk]: {
    eventName: '点击【一指禅视频】',
  },
  [TrackerCustomEvent.RfSkillVideoClk]: {
    eventName: '点击【射频视频】',
  },
  [TrackerCustomEvent.SwSkillVideoClk]: {
    eventName: '点击【冲击波视频】',
  },
  [TrackerCustomEvent.MoxSkillVideoClk]: {
    eventName: '点击【矩阵艾灸视频】',
  },
  [TrackerCustomEvent.HotstoneSkillVideoClk]: {
    eventName: '点击【热砭石视频】',
  },
  [TrackerCustomEvent.WifiLocationInfo]: {
    eventName: 'WIFI和基站定位获取失败',
    action: '监控',
    paramsMapper: params => {
      return {
        LocationInfoByTheSDK: params.c1,
        LocationInfoByWIFIBaseStations: params.c2,
      };
    },
  },
  // ——————————————————
  [TrackerCustomEvent.CommonProblemClk]: {
    eventName: '点击【常见问题】',
  },
  [TrackerCustomEvent.ReleaseNoteClk]: {
    eventName: '点击【版本说明】',
  },
  [TrackerCustomEvent.UseDescClk]: {
    eventName: '点击【使用说明书】',
  },
  [TrackerCustomEvent.OpenCameraError]: {
    eventName: '打开摄像头失败的日志',
    paramsMapper: params => {
      return { '[打开摄像头失败的原因]': params.c1 };
    },
  },
  [TrackerCustomEvent.MassagePlanDetailsClk]: {
    eventName: '按摩页面点击查看方案详情',
    paramsMapper: params => {
      return {
        '[按摩页面点击查看方案详情]按摩类型': params.c1,
      };
    },
  },
  [TrackerCustomEvent.ViewMemberInfoClk]: {
    eventName: '查看会员档案详情',
    paramsMapper: params => {
      return {
        '[查看会员档案详情]点击场景': params.c1,
      };
    },
  },
  [TrackerCustomEvent.EditMemberInfoClk]: {
    eventName: '编辑会员档案',
    paramsMapper: params => {
      return {
        '[编辑会员档案]来源': params.c1,
      };
    },
  },
  [TrackerCustomEvent.UpdateMemberInfoClk]: {
    eventName: '更新会员档案',
  },
  [TrackerCustomEvent.DeviceGPSAbnormal]: {
    eventName: '设备获取不到GPS',
    paramsMapper: params => {
      return {
        '[设备获取不到GPS]PadID': params.c1,
        '[设备获取不到GPS]deviceSystemInfo': params.c2,
      };
    },
  },
  [TrackerCustomEvent.GetWifiLocError]: {
    eventName: 'WIFI和基站定位获取失败',
    paramsMapper: params => {
      return {
        '[WIFI和基站定位获取失败]失败原因': params.c1,
      };
    },
  },
  [TrackerCustomEvent.LanConnectError]: {
    eventName: '局域网连接错误',
    paramsMapper: params => {
      return {
        '[局域网连接错误]ssid': params.c1,
        '[局域网连接错误]ip': params.c2,
      };
    },
  },

  [TrackerCustomEvent.ServiceRecordByTimeDimensionClk]: {
    eventName: '查看服务记录通过时间维度',
    paramsMapper: params => {
      return {
        '[查看服务记录通过时间维度]': params.c1,
      };
    },
  },
  [TrackerCustomEvent.ViewMemberRecordSortClk]: {
    eventName: '【服务详情】会员记录Tab的筛选条件',
    paramsMapper: params => {
      return {
        '[服务详情会员记录Tab的筛选条件]': params.c1,
        '[服务详情会员记录Tab的排序条件]': params.c2,
      };
    },
  },
  [TrackerCustomEvent.ViewMemberRecordClk]: {
    eventName: '【服务详情】点击会员记录Tab',
  },
  [TrackerCustomEvent.MemberConsumptionDetailClk]: {
    eventName: '【服务详情】服务记录Tab订单详情',
  },
  [TrackerCustomEvent.FillInPhysicalInfoSource]: {
    eventName: '填写理疗方案来源',
    paramsMapper: params => {
      return {
        '[填写理疗方案来源]维度': params.c1,
        '[填写理疗方案来源]来源': params.c2,
      };
    },
  },
  [TrackerCustomEvent.ViewMemberEffectRecordClk]: {
    eventName: '查看会员单次理疗记录中的效果记录',
  },
  [TrackerCustomEvent.ViewMemberTherapyAppealClk]: {
    eventName: '查看用户理疗诉求',
  },

  [TrackerCustomEvent.AiConsultationClk]: {
    eventName: '点击去AI问诊',
    paramsMapper: params => {
      return {
        '[点击去AI问诊]': params.c1,
      };
    },
  },
  [TrackerCustomEvent.RecommendToTherapy]: {
    eventName: '推荐方案点击去理疗来源',
    paramsMapper: params => {
      return {
        '[推荐方案点击去理疗来源]': params.c1,
      };
    },
  },
  [TrackerCustomEvent.AiConsultationSkipClk]: {
    eventName: 'AI问诊点击跳过',
    paramsMapper: params => {
      return {
        '[AI问诊点击跳过]来源': params.c1, //跳过舌诊|跳过症状确认
      };
    },
  },
  [TrackerCustomEvent.SuggestionsForFeedback]: {
    eventName: '提示建议的反馈情况',
    paramsMapper: params => {
      return {
        '[提示建议的反馈情况]商品ID': params.c1,
        '[提示建议的反馈情况]订单ID': params.c2,
        '[提示建议的反馈情况]理疗阶段': params.c3,
        '[提示建议的反馈情况]帮助情况': params.c4,
      };
    },
  },
  [TrackerCustomEvent.RecordInfoDisclaimerClause]: {
    eventName: '记录免责条款弹窗信息',
    paramsMapper: params => {
      return {
        '[记录免责条款弹窗信息]查看弹窗的时长(单位：秒)': params.c1,
        '[记录免责条款弹窗信息]点击[我已知晓并同意]的时刻': params.c2,
        '[记录免责条款弹窗信息]理疗门店': params.c3,
      };
    },
  },
  [TrackerCustomEvent.ServiceRecordDrawerAlertShow]: {
    eventName: '【订单评价】抽屉弹出的总次数',
    desc: '包括以下情况：1、点击服务详情卡片 2、服务流程结束后弹出的评价',
  },
  [TrackerCustomEvent.ServiceRecordDrawerAlertSubmit]: {
    eventName: '【订单评价】成功提交的总次数',
    desc: '包括以下情况：1、点击服务详情卡片 2、服务流程结束后弹出的评价',
  },
  [TrackerCustomEvent.ServiceRecordDrawerAlertSkip]: {
    eventName: '【订单评价】点击跳过的总次数',
    desc: '只有服务正常结束才有跳过评价按钮',
  },
  [TrackerCustomEvent.ServiceRecordDrawerShowTimes]: {
    eventName: '【服务详情】页面补充订单信息的总次数',
  },
  [TrackerCustomEvent.LeaveServiceRecordPage]: {
    eventName: '【服务详情】单次进入页面-相关统计',
    paramsMapper: params => {
      return {
        '[服务详情单次进入页面-相关统计]服务记录卡片点击次数': params.c1,
        '[服务详情单次进入页面-相关统计]单次进入页面-评价抽屉去补充按钮点击次数': params.c2,
      };
    },
  },
  [TrackerCustomEvent.GoServiceRecordDrawerSupplyButton]: {
    eventName: '【服务详情】页面订单评价去补充按钮点击次数',
  },
  [TrackerCustomEvent.R2PreheatClick]: {
    eventName: 'R2预热点击量汇总',
    paramsMapper: params => {
      return {
        'R2预热点击量[文案]': params.c1,
        'R2预热点击量[图片]': params.c2,
      };
    },
  },
  [TrackerCustomEvent.ReceiveExceptionEventCapture]: {
    eventName: '收到异常事件捕获',
    paramsMapper: params => {
      return {
        事件名称: params.c1,
        事件等级: params.c2,
        时间节点: params.c3,
      };
    },
  },
  [TrackerCustomEvent.ExceptionEventRecovery]: {
    eventName: '异常事件恢复',
    paramsMapper: params => {
      return {
        事件名称: params.c1,
        事件等级: params.c2,
        时间节点: params.c3,
      };
    },
  },
  // 添加其他事件的映射...
};
